<template>
  <div class="inputs">
    <el-input
      v-for="i in count"
      :key="i"
      size="mini"
      placeholder="请输入"
      :value="value[i - 1]"
      @input="input(i - 1, $event)"
    >
    </el-input>
  </div>
</template>

<script>
export default {
  props: {
    value: Array,
    count: [Number, String]
  },
  watch: {
    count() {
      this.computeValue();
    }
  },
  methods: {
    input(i, value) {
      const v = [...this.value];
      v[i] = value;
      this.$emit('input', v);
    }
  }
};
</script>

<style lang="less" scoped>
.inputs {
  width: 200px;
}
</style>
